<div class="main_content px-3 position-relative">

    <div class="container-fluid py-3">

        <div class="title mb-4">
            <h2>Help & Contact Centre</h2>
        </div>

        <div class="row">
            <div class="col-lg-12 col-md-12 main_img">
                <h5 class="dash_subheading ">Regions</h5>
                <div class="white_box shadow p-3">
                    <div class="purchase_div">
                        <div class="job_plan mb-4 mt-4">
                            <div class="row ">
                                <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
                                    <div class="card text-center">
        
                                        <img loading="lazy" src="../../../assets/images/new/singapore.jfif" alt="" class="country_img">
        
                                        <h3>Singapore</h3>
        
                                        <a class="yellow_btn mx-auto my-3 ">Contact Now</a>
                                    </div>
                                </div>

                                <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
                                    <div class="card text-center">
        
                                        <img loading="lazy" src="../../../assets/images/new/malaysia.jpg" alt="" class="country_img">
        
                                        <h3>Malaysia</h3>
        
                                        <a class="yellow_btn mx-auto my-3 ">Contact Now</a>
                                    </div>
                                </div>

                                <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
                                    <div class="card text-center">
        
                                        <img loading="lazy" src="../../../assets/images/new/vietnam.jfif" alt="" class="country_img">
        
                                        <h3>Vietnam</h3>
        
                                        <a class="yellow_btn mx-auto my-3 ">Contact Now</a>
                                    </div>
                                </div>

                                <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
                                    <div class="card text-center">
        
                                        <img loading="lazy" src="../../../assets/images/new/indonesia.jpg" alt="" class="country_img">
        
                                        <h3>Indonesia</h3>
        
                                        <a class="yellow_btn mx-auto my-3 ">Contact Now</a>
                                    </div>
                                </div>

                                <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
                                    <div class="card text-center">
        
                                        <img loading="lazy" src="../../../assets/images/new/hongkong.jfif" alt="" class="country_img">
        
                                        <h3>Hong Kong</h3>
        
                                        <a class="yellow_btn mx-auto my-3 ">Contact Now</a>
                                    </div>
                                </div>

                                <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
                                    <div class="card text-center">
        
                                        <img loading="lazy" src="../../../assets/images/new/australia.jfif" alt="" class="country_img">
        
                                        <h3>Australia</h3>
        
                                        <a class="yellow_btn mx-auto my-3 ">Contact Now</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>